import * as React from 'react';
import {
  List,
  Datagrid,
  Filter,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  DateInput,
  TextField,
  DateField,
  SelectByEnum,
  ReferenceField,
  ReferenceInput,
} from 'react-admin';
import { TextByEnum } from './custom/Enum';

const useTxtData = {
  table: {
    id: 'id',
    S_xumu_id: '畜牧',
    zhishu: '健康指数',
    level: '健康等级',
    tiwen_status: '体温状态',
    yundong_status: '运动状态',
    shipin_status: '进食状态',
    AtTime: '计算时间',
  }
};

export const S_xumu_healthList = (props) => (
  <List {...props} filters={<Filters />}>
    <Datagrid>
      <TextField label={useTxtData.table.id} source="id" />
      <ReferenceField label={useTxtData.table.S_xumu_id} source="S_xumu_id" reference="Admin/CMSS_xumu">
        <TextField source="name" />
      </ReferenceField>
      <TextField label={useTxtData.table.zhishu} source="zhishu" />
      <TextByEnum label={useTxtData.table.level} source="level" EnumName='api.Models.S_xumu_healthLevel' />
      <TextField label={useTxtData.table.tiwen_status} source="tiwen_status" />
      <TextField label={useTxtData.table.yundong_status} source="yundong_status" />
      <TextField label={useTxtData.table.shipin_status} source="shipin_status" />
      <DateField label={useTxtData.table.AtTime} source="AtTime" showTime />
    </Datagrid>
  </List>
);

const Filters = (props) => (
  <Filter {...props}>
    <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu" alwaysOn>
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

export const S_xumu_healthEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <NumberInput label={useTxtData.table.zhishu} source="zhishu" />
      <SelectInput label={useTxtData.table.level} source="level" choices={[
        { id: '优', name: '优' },
        { id: '良', name: '良' },
        { id: '中', name: '中' },
        { id: '差', name: '差' },
      ]} />
      <TextInput label={useTxtData.table.tiwen_status} source="tiwen_status" />
      <TextInput label={useTxtData.table.yundong_status} source="yundong_status" />
      <TextInput label={useTxtData.table.shipin_status} source="shipin_status" />
      <DateInput label={useTxtData.table.AtTime} source="AtTime" />
    </SimpleForm>
  </Edit>
);

export const S_xumu_healthCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <NumberInput label={useTxtData.table.zhishu} source="zhishu" />
      <SelectInput label={useTxtData.table.level} source="level" choices={[
        { id: '优', name: '优' },
        { id: '良', name: '良' },
        { id: '中', name: '中' },
        { id: '差', name: '差' },
      ]} />
      <TextInput label={useTxtData.table.tiwen_status} source="tiwen_status" />
      <TextInput label={useTxtData.table.yundong_status} source="yundong_status" />
      <TextInput label={useTxtData.table.shipin_status} source="shipin_status" />
      <DateInput label={useTxtData.table.AtTime} source="AtTime" />
    </SimpleForm>
  </Create>
);